// extracted by mini-css-extract-plugin
export default {"heading":"vD-z","corrected":"wD-z","redirectVerbiageContainer":"xD-z","redirectVerbiageText":"yD-z"};